import _ from 'lodash';
import { makeCell } from './gridUtill';
let fields = [];
let columns = [];

// ID 컬럼 (숨김)
makeCell(
  1,
  [
    {
      field: 'id',
      alias: 'ID',
      indexExclusive: true,
      visible: false,
    },
  ],
  fields,
  columns,
);

// 용매조성코드 컬럼
makeCell(
  1,
  [
    {
      field: 'code',
      alias: '용매조성코드',
      indexExclusive: true,
      width: 200, // 기존 너비에서 50 증가
    },
  ],
  fields,
  columns,
);

makeCell(
  1,
  [
    {
      field: 'idx',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
);
makeCell(
  1,
  [
    {
      field: 'ww',
      alias: 'w/w',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
);
makeCell(
  8,
  [
    {
      field: 'solvent',
      alias: 'solvent',
    },
    {
      field: 'solventVol',
      alias: 'vol%',
      excelKey: 'vol%_',
    },
  ],
  fields,
  columns,
);
makeCell(
  5,
  [
    {
      field: 'salt',
      alias: 'salt',
    },
    {
      field: 'saltVol',
      alias: 'M,wt%',
      excelKey: 'M,wt%_',
    },
  ],
  fields,
  columns,
);
makeCell(
  1,
  [
    {
      field: 'density',
      alias: '밀도',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
);
// makeCell(
//   1,
//   [
//     {
//       field: "sum",
//       alias: "SUM",
//       indexExclusive: true,
//     },
//   ],
//   fields,
//   columns
// );
makeCell(
  1,
  [
    {
      field: 'note',
      alias: '비고',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
);

const rowSet = _.reduce(
  fields,
  (a, v) => {
    if (v.excelKey) {
      a.push({
        key: v.fieldName,
        value: v.excelKey,
      });
    }
    return a;
  },
  [],
);
export { fields, columns, rowSet };
